import { t } from "../../i18n/index.ts";
import { Button } from "../../ui/Button.tsx";
import { Dialog, DialogActions } from "../../ui/Dialog.tsx";
import { CopyButton } from "../../ui/misc.tsx";

/** Shows a freshly created secret (API key, webhook signing secret) once. */
export function Secret({ secret, onClose }: { secret: string | null; onClose: () => void }) {
  return (
    <Dialog open={secret !== null} onClose={onClose} title={t("settings.secretTitle")}>
      <p class="text-sm text-zinc-700">{t("settings.secretHint")}</p>
      <code class="block rounded-md bg-zinc-100 p-3 text-sm break-all">{secret}</code>
      <DialogActions>
        <CopyButton text={secret ?? ""} label={t("common.copy")} />
        <Button answer="confirm" variant="primary" onClick={onClose}>
          {t("common.done")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
